import { Suspense, lazy } from "react";
import DashboardLayout from "../layouts/dashboard";
import { PATH_TASKS } from "./paths";
import AuthGuard from "../guards/AuthGuard";
import RoleGuard from "@/guards/RoleGuard";

const Tasks = lazy(() => import("@pages/tasks"));

const tasksRoutes = [
  {
    path: PATH_TASKS,
    element: (
      <AuthGuard>
        <RoleGuard>
          <DashboardLayout>
            <Suspense>
              <Tasks />
            </Suspense>
          </DashboardLayout>
        </RoleGuard>
      </AuthGuard>
    ),
  },
];

export default tasksRoutes;
